/* eslint-disable global-require */
export default {
  scaly: require('./scaly.json'),
  furry: require('./furry.json'),
  feathery: require('./feathery.json'),
};
